import { Component, OnInit, Inject } from '@angular/core';
import {   MatDialogRef,   MAT_DIALOG_DATA } from '@angular/material/dialog';

export interface DialogData{
  name: string;
  description: string;
}

@Component({
  selector: 'app-dialog-delete-symptom',
  templateUrl: './dialog-delete-symptom.component.html',
  styleUrls: ['./dialog-delete-symptom.component.scss']
})
export class DialogDeleteSymptomComponent implements OnInit {

  checked:boolean = false;

  constructor(public dialogRef: MatDialogRef<DialogDeleteSymptomComponent>, @Inject(MAT_DIALOG_DATA) public data: DialogData) { }

  ngOnInit(): void {
    this.checked = false;
  }
}


